module.exports = __webpack_public_path__ + "e754f7fd4a69e7a3301bdce96810cac2.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/speech-to-text/start_recording.mp3
// module id = 3275
// module chunks = 0